import React from 'react';

import Slider from '@material-ui/core/Slider';
import styled from 'styled-components';

import theme from 'constants/theme';

const RangeSlider = ({
  value,
  onChange,
  valuetext,
  color = theme.palette.primary.main,
  disabled = false,
  thumbsAreInCenter,
  min,
  max,
  ...props
}) => {
  const valueHandler = (value) => {
    if (thumbsAreInCenter) {
      return value.map((v) => (v === '' ? Math.round(((max + min) / 2) * 100) / 100 : +v));
    }
    return value.map((v) => +v);
  };

  return (
    <StyledSlider
      value={valueHandler(value)}
      onChange={onChange}
      valueLabelDisplay="auto"
      getAriaValueText={valuetext}
      color={color}
      disabled={disabled}
      min={min !== -Infinity ? min : -100}
      max={max !== Infinity ? max : 100}
      {...props}
    />
  );
};
const StyledSlider = styled(Slider)`
  .MuiSlider-thumb {
    margin-top: -0.725rem;
    width: 1.5rem;
    height: 1.5rem;
    border: 0.25rem solid white;
    box-shadow: 3px 4px 5px ${(props) => props.theme.palette.shadows.popper};
  }
  .MuiSlider-valueLabel {
    left: calc(-50%);
  }
  .MuiSlider-markLabelActive {
    font-size: 0.75rem;
    color: ${(props) => props.theme.palette.text.label};
  }
`;
export default RangeSlider;
